function FooterBar() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brandLine">
          <span className="site-footer__brandName">令牌额度与调用日志查询</span>
        </div>
        <div className="site-footer__page">当前页面：额度查询工具</div>
      </div>
    </footer>
  );
}

export default FooterBar;
